import {
  matchQuery,
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { shouldRetryQuery } from '@repo/lib';
import { ThemeProvider } from '@ui/providers';
// import { SnowEffectProvider } from '@ui/providers';
import { StrictMode, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import './global.css';
import './index.css';
import { getRouter } from './routes/router';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
      staleTime: 60 * 1000 * 10,
    },
  },
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      void queryClient.invalidateQueries({
        predicate: (query) =>
          !!mutation?.meta?.invalidateKeys?.some((queryKey) =>
            matchQuery({ queryKey }, query),
          ),
      });
    },
  }),
});

function App() {
  const router = useMemo(() => getRouter(), []);
  return (
    <StrictMode>
      <ThemeProvider
        defaultTheme="light"
        storageKey="admin-theme"
      >
        {/* Christmas features disabled. Uncomment to re-enable snow effect. */}
        {/* <SnowEffectProvider> */}
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
        {/* </SnowEffectProvider> */}
      </ThemeProvider>
    </StrictMode>
  );
}

export default App;
